import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { map, Observable, of, shareReplay } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { LanguageService } from '@spartacus/core';
import { subscribe } from 'node:diagnostics_channel';

@Component({
  selector: 'app-coreDocumentsTab',
  templateUrl: './kb-coreDocumentsTab.component.html',
  styleUrls: ['./kb-coreDocumentsTab.component.scss'],
  standalone: false
})
export class KbCoreDocumentsTabComponent {
  @Input() Docs: any;
  activeLanguage$!: Observable<string>;
  documentUrlsMap: { [key: string]: string } = {};
  constructor(private documentService: GetDocumentService, private languageService: LanguageService) { }

  ngOnInit() {
    this.Docs?.forEach((doc: any) => {
      if (doc?.code) {
        this.loadDocument(doc.code);
      }
    });
  }


  loadDocument(code: string): void {
    this.documentService
      .getDocumentByDocumentCode(code)
      .pipe(
        map((res: any) => res?.url ?? '')
      )
      .subscribe((url: string) => {
        this.documentUrlsMap[code] = url;
      });
  }

}
